export const HEADER_STATION_NAME_COLOR = "#3a5278";

export const HEADER_STATION_NAME_HOVER_COLOR = "#2e4166";

export const HEADER_STATION_NAME_FONT_WEIGHT = 600;
